import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
export function Customers() {
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [name, setName] = useState("");
    const [customerCode, setCustomerCode] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [mobile, setMobile] = useState("");
    const [address, setAddress] = useState("");
    const [saving, setSaving] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
    function load() {
        api.get("/customers").then((r) => setItems(r.items)).catch(() => setError("Couldn't load customers."));
    }
    useEffect(load, []);
    const visibleItems = items.filter((c) => {
        if (!search.trim())
            return true;
        const q = search.trim().toLowerCase();
        return (c.name.toLowerCase().includes(q) ||
            (c.customerCode ?? "").toLowerCase().includes(q) ||
            (c.mobile ?? "").toLowerCase().includes(q));
    });
    async function create() {
        const errs = {};
        if (!name.trim())
            errs.name = "Customer name is required.";
        setFieldErrors(errs);
        if (Object.keys(errs).length)
            return;
        setSaving(true);
        setError(null);
        try {
            await api.post("/customers", {
                name: name.trim(),
                customerCode: customerCode.trim() || undefined,
                contactPerson: contactPerson.trim() || undefined,
                mobile: mobile.trim() || undefined,
                address: address.trim() || undefined,
            });
            setName("");
            setCustomerCode("");
            setContactPerson("");
            setMobile("");
            setAddress("");
            setShowForm(false);
            load();
        }
        catch (e) {
            setError(e?.code === "forbidden" ? "You don't have permission to add customers." : "Couldn't save this customer.");
        }
        finally {
            setSaving(false);
        }
    }
    return (<div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: "1.6rem", margin: 0 }}>Customers</h1>
        <button onClick={() => setShowForm((v) => !v)} style={btnStyle}>{showForm ? "Cancel" : "+ New Customer"}</button>
      </div>

      <input placeholder="Search by name, code, or mobile…" value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: "100%", maxWidth: 420, border: "1px solid var(--line)", borderRadius: 8, padding: "9px 12px", fontSize: "0.85rem", fontFamily: "inherit", marginBottom: 14 }}/>

      {error && <div style={{ color: "var(--st-risk)", marginBottom: 12 }}>{error}</div>}

      {showForm && (<div style={{ background: "var(--surface)", border: "1px solid var(--line-soft)", borderRadius: 10, padding: 16, marginBottom: 18 }}>
          <div className="lg-stack" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
            <div>
              <input placeholder="Customer name *" value={name} onChange={(e) => setName(e.target.value)} style={inputStyle}/>
              {fieldErrors.name && <div style={errText}>{fieldErrors.name}</div>}
            </div>
            <input placeholder="Customer code (optional)" value={customerCode} onChange={(e) => setCustomerCode(e.target.value)} style={inputStyle}/>
            <input placeholder="Contact person" value={contactPerson} onChange={(e) => setContactPerson(e.target.value)} style={inputStyle}/>
            <input placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} style={inputStyle}/>
            <input placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} style={{ ...inputStyle, gridColumn: "span 2" }}/>
          </div>
          <button onClick={create} disabled={saving} style={{ ...btnStyle, marginTop: 12 }}>Save Customer</button>
        </div>)}

      <div style={{ background: "var(--surface)", border: "1px solid var(--line-soft)", borderRadius: 10, overflow: "hidden" }}>
        {visibleItems.map((c) => (<Link key={c.id} to={`/legal-cases/customers/${c.id}`} style={{ display: "flex", justifyContent: "space-between", padding: "12px 18px", borderTop: "1px solid var(--line-soft)", textDecoration: "none", color: "inherit" }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: "0.88rem" }}>{c.name}</div>
              <div className="mono" style={{ fontSize: "0.72rem", color: "var(--ink-faint)" }}>{c.customerCode ?? "—"} {c.mobile ? `· ${c.mobile}` : ""}</div>
            </div>
          </Link>))}
        {visibleItems.length === 0 && !error && (<div style={{ padding: 24, textAlign: "center", color: "var(--ink-faint)", fontSize: "0.85rem" }}>
            {search.trim() ? "No customers match your search." : "No customers yet."}
          </div>)}
      </div>
    </div>);
}
const inputStyle = { border: "1px solid var(--line)", borderRadius: 8, padding: "8px 10px", fontSize: "0.82rem", fontFamily: "inherit", width: "100%" };
const btnStyle = { background: "var(--brand)", color: "#fff", fontWeight: 600, fontSize: "0.82rem", padding: "8px 16px", borderRadius: 8, border: "none", cursor: "pointer" };
const errText = { color: "var(--st-risk)", fontSize: "0.72rem", marginTop: 3 };
